import { createFeatureSelector } from "@ngrx/store"
import { State as WidgetGalleryState } from "../reducers/widget-gallery.reducers"

export const selectWidgetGalleryState = createFeatureSelector<WidgetGalleryState>('widgetGallery');
